import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cpfFormat'
})
export class CpfFormatPipe2 implements PipeTransform {

  transform(cpf?: string): string {
    
    if (!cpf) {
      return '';
    }

    const numericValue = cpf.replace(/\D/g, '');

    return numericValue.replace(
      /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
      '$1.$2.$3-$4'
    );
  }

}
